/**
 * 公共参数的配置文件
 * **/

const api = {
    quickUserLogin: '/bss/app/noauth/QuickUserLogin',
    // 单国家流量包
    queryOfferList: '/bss/app/noauth/QueryOfferList',
    // 州流量包
    queryRecommendOfferList: '/bss/app/noauth/QueryRecommendOfferList',
    // 积分 -- Redeem Coupon
    queryIntegralPromotionList: '/bss/app/integral/QueryIntegralPromotionList',
    // 积分 -- Redeem Package、Redeem Top-up Card
    queryIntegralGoodList: '/bss/app/integral/QueryIntegralGoodList',
    // 用户积分
    queryUserIntegral: '/bss/app/integral/QueryUserIntegral',
    // 用户积分明细
    queryIntegralDetailes: '/bss/app/integral/QueryIntegralDetailes',
    dictionary: '/aps/dictionary/query',
    // 获取会员状态
    queryUserVIPState: '/bss/app/user/queryUserVIPState',
    // 查询会员权益
    queryVIPBenefitsByGoods: '/bss/app/integral/QueryVIPBenefitsByGoods',
    // 查询优惠券
    queryCustPromotionByGoods: '/bss/app/promotion/queryCustPromotionByGoods',
    // 查询账户余额
    queryBalanceInfo: '/bss/app/user/QueryBalanceInfo',
    // 创建订单
    createOrder: '/bss/app/order/CreateOrder',
    // 使用账户余额支付接口
    doPayByBalance: '/bss/app/order/DoPayByBalance',
    // 提前计算下单需要的费用
    preCalcOrder: '/bss/app/order/PreCalcOrder',
    // 在线支付调用
    //business_order_internal_create: '/business/order/internal/create',
    // 中台收银台下单接口
    cashier_createorder: '/webmps/payment/cashier/createorder',
    queryOrderListForApp: '/bss/app/order/queryOrderListForApp',
    //获取用户信息
    getUserInfo: '/bss/app/user/QueryUserInfo',
    //首页banner
    queryBanner: '/webmps/marketing/banner/queryAll',
    //首页专属套餐列表
    queryCustomOfferList: '/bss/app/noauth/QueryCustomOfferList',
    //首页热门地区推荐
    queryDictionaryValueListInfo: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
    //跨区域套餐展示
    queryRecommendLowPrice: '/bss/app/noauth/QueryRecommendLowPrice',
    //当前所在地获取
    queryOnlineTerminal: '/bss/app/terminal/QueryOnlineTerminal',
    //覆盖国家列表
    queryCoverCountyInfo: '/bss/app/noauth/QueryCoverCountyInfo',
    // 查询用户绑定的设备
    queryGroupList: '/bss/app/group/QueryGroupList',
    makeInviterCode: '/bss/app/user/MakeInviterCode',
    queryInviteesJoinActList :'/bss/app/act/queryInviteesJoinActList',
    getVerificationCode: '/mms/app/httpApi/v1/esim/getVerificationCode'

};

const config = {
    api,
    request: {
        partnerCode: 'UKAPP',
        streamNoHead: 'APP'
    }
};

export default config;




// WEBPACK FOOTER //
// ./src/config/config.js